<ion-content>
  <shared-close (tap)="select()"></shared-close>
  <ion-list class="language-modal-list">
    <ion-item class="language-modal-list__item" *ngFor="let language of params.languages" (tap)="select(language.key)">
      <span class="language-modal-list__item__flag --{{language.key}}-flag"></span>
      {{ language.name }}
    </ion-item>
  </ion-list>
</ion-content>